import styled, { css } from 'styled-components';
import UnstyledButton from 'components/UnstyledButton';
import { hoverable } from 'styles/media';
import { ACTIVE_BOX_SHADOW } from './constants';

export const Button = styled(UnstyledButton)`
  ${(props) => css(props.theme.typography.variants.button.default)}
  align-items: center;
  border: none;
  display: inline-flex;
  justify-content: center;
  outline: 0px;
  padding: 0px;
  position: relative;
  text-decoration: none;
  text-align: center;
  user-select: none;

  ${hoverable`
    cursor: pointer;
  `}

  &[disabled] {
    cursor: not-allowed;
    opacity: 0.35;
  }

  &:active:not([disabled]) {
    box-shadow: ${ACTIVE_BOX_SHADOW};
  }
`;
